"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const asyncThrottler = require("@tanstack/pacer/async-throttler");
const reactStore = require("@tanstack/react-store");
const PacerProvider = require("../provider/PacerProvider.cjs");
function useAsyncThrottler(fn, options, selector = () => ({})) {
  const mergedOptions = {
    ...PacerProvider.useDefaultPacerOptions().asyncThrottler,
    ...options
  };
  const [asyncThrottler$1] = react.useState(
    () => new asyncThrottler.AsyncThrottler(fn, mergedOptions)
  );
  asyncThrottler$1.fn = fn;
  asyncThrottler$1.setOptions(mergedOptions);
  const state = reactStore.useStore(asyncThrottler$1.store, selector);
  react.useEffect(() => {
    return () => asyncThrottler$1.cancel();
  }, [asyncThrottler$1]);
  return react.useMemo(
    () => ({
      ...asyncThrottler$1,
      state
    }),
    // omit `store` in favor of `state`
    [asyncThrottler$1, state]
  );
}
exports.useAsyncThrottler = useAsyncThrottler;
//# sourceMappingURL=useAsyncThrottler.cjs.map
